// extracted by mini-css-extract-plugin
module.exports = {"LoadingIndicatorLabel":"LoadingIndicator_LoadingIndicatorLabel__xnVcB"};